<template>
    <div v-if="open" class="popup" :class="mode">
        <div class="bg" @click="close"></div>
        <div class="box">
            <div class="content"><slot></slot></div>
            <div class="close" @click="close">
                <CloseIcon/>
            </div>
        </div>
    </div>
</template>

<script>
    import gsap from 'gsap'
	import CloseIcon from "@/assets/icons/close.svg"
	export default {
		name: "Popup",
        props: ['open','mode'],
		mounted()
		{
			if(this.open === true)
			{
				this.easeIn();
			}
		},
		watch: {
			open: function(from){
				if(from === true){
					this.easeIn();
                }
            }
        },
        methods: {
			close(){
				this.$emit('closePopup');
            },
	        easeIn(){
		        setTimeout(function(){
			        gsap.to('.box', {
				        duration: 0.3,
				        opacity: 1,
				        y: '-50%',
				        ease: 'power1.easeOut'
			        })
		        }, 100);
	        }
        },
		components: {
			CloseIcon
		}
	}
</script>

<style lang="scss">
    .popup{
        position: fixed !important;
        top: 0; left: 0;
        right: 0; bottom: 0;
        width: 100%; height: 100%;
        .bg{
            top: 0; left: 0;
            right: 0; bottom: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.5) !important;
        }
        .box{
            width: 400px;
            max-width: calc(100% - 30px);
            background: $orange;
            padding: 15px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-25%);
            border-radius: 24px;
            opacity: 0;
            .close{
                position: absolute;
                top: -5px;
                right: -10px;
                width: 43px;
                height: 43px;
                background: $white;
                border-radius: 50%;
                cursor: pointer;
                svg{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
            .active-chats{
                max-height: calc(80vh - 120px);
                overflow-x: hidden;
                overflow-y: auto;
            }
            .create-chat{
                max-height: 70vh;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }
        &.chat{
            .box{
                padding: 35px 30px;
            }
        }
        &.prompt{
            z-index: 100;
            .box{
                padding: 35px 30px;
                h2{
                    margin-top: 0px;
                    color: $white;
                }
                p{
                    display: block;
                    font-size: 16px;
                    font-weight: normal;
                    color: $white;
                    margin: 0px auto 30px;
                }
                button{
                    text-transform: none;
                }
            }
        }
        &.notification{
            .box{
                padding: 35px 55px;
                border-radius: 55px;
                border: 3px solid $white;
                .content{
                    font-size: 17px;
                    font-weight: bold;
                    color: $white;
                }
            }
        }
        &.tivoli{
            background: transparent !important;
            .box{
                background: $green;
                padding: 50px 30px;
                @media(max-width: 767px){padding: 30px;}
                @media(max-width: 850px) and (orientation: landscape){padding: 30px;}
                .content{
                    text-align: center;
                    p{
                        display: block;
                        font-size: 20px;
                        font-weight: bold;
                        color: $white;
                        max-width: 200px;
                        margin: 0px auto;
                        &.small{
                            font-size: 14px;
                            line-height: 1.4em;
                            display: block;
                            margin: 50px auto;
                            max-width: 100%;
                            font-weight: normal;
                            font-style: italic;
                            @media(max-width: 767px){margin: 20px auto;}
                            @media(max-width: 850px) and (orientation: landscape){margin: 20px auto;}
                        }
                    }
                    .winnings{
                        line-height: 1.2em;
                        font-size: 26px;
                        font-weight: bold;
                        color: $dark;
                        padding-top: 50px;
                        @media(max-width: 767px){padding-top: 20px;}
                        @media(max-width: 850px) and (orientation: landscape){padding-top: 20px;}
                    }
                }
                button{
                    color: $green;
                }
            }
        }
        &.tshirt{
            z-index: 15;
            .box{
                background: $green;
                padding: 50px 30px;
                @media(max-height: 750px){
                    padding: 0px;
                }
                .content{
                    text-align: center;
                    @media(max-height: 750px){
                        max-height: 80vh;
                        padding: 30px 20px;
                        overflow-x: hidden;
                        overflow-y: auto;
                    }
                    h2{
                        margin-top: 0px;
                        color: $white;
                    }
                    p{
                        display: block;
                        font-size: 20px;
                        font-weight: bold;
                        color: $white;
                        max-width: 200px;
                        margin: 0px auto;
                        &.small{
                            font-size: 16px !important;
                            max-width: 100% !important;
                            font-weight: normal !important;
                            strong{
                                display: block;
                                margin-bottom: 8px;
                                font-size: 20px;
                            }
                        }
                        &.free-shipping{
                            font-size: 12px;
                            font-style: italic;
                        }
                    }
                    img{
                        margin: 20px auto 15px;
                        @media(max-height: 750px){
                            width: 50%;
                        }
                    }
                    ul.sizes{
                        margin: 30px -30px;
                        padding: 0px;
                        text-align: center;
                        li{
                            display: inline-block;
                            width: 38px;
                            height: 38px;
                            border-radius: 50%;
                            border: 2px solid $white;
                            margin: 0px 5px;
                            font-size: 13px;
                            text-align: center;
                            line-height: 34px;
                            color: $white;
                            text-transform: uppercase;
                            cursor: pointer;
                            &.selected{
                                background: $white;
                                color: $green;
                            }
                        }
                    }
                    .winnings{
                        height: 270px;
                        line-height: 270px;
                        font-size: 26px;
                        font-weight: bold;
                        color: $dark;
                    }
                }
                button{
                    color: $green;
                }
            }
        }
        &.showkey{
            z-index: 1;
            .box{
                padding: 25px 30px 50px;
                text-align: center;
                @media(max-height: 750px){
                    padding: 0px;
                    .content{
                        max-height: 80vh;
                        overflow-x: hidden;
                        overflow-y: auto;
                        padding: 25px 30px 50px;
                    }
                }
                h2{
                    color: $white;
                }
                p{
                    font-weight: normal;
                    font-size: 16px;
                    &.small{
                        font-size: 14px;
                        font-style: italic;
                    }
                }
                .alias{
                    border: 2px dashed $white;
                    padding: 10px;
                    font-size: 20px;
                    font-weight: bold;
                    color: $white;
                    text-align: center;
                    margin-top: 30px;
                    margin-bottom: 30px;
                    position: relative;
                    .bubble{
                        position: absolute;
                        bottom: 65px;
                        left: 50%;
                        transform: translateX(-50%);
                        color: $dark;
                    }
                }
            }
        }
    }
</style>
